export default class caminhoGlobal {

    constructor(
        index= '/',
        index_error= '/error',
        codigo = '/codigo',
        index_juridico= '/',
        endereco = '/endereco',
        documentos= '/documentos',
        rota_erro_404 = '/error'
    ) {
        this.index = index;
        this.index_error = index_error;
        this.index_juridico = index_juridico;
        this.codigo = codigo;
        this.endereco = endereco;
        this.documentos = documentos;
        this.rota_erro_404 = rota_erro_404;
    }
}